import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="clear-storage"
export default class extends Controller {
  connect() {
    this.clearStorageOnUrlChange = this.clearStorageOnUrlChange.bind(this);
    document.addEventListener("turbo:visit", this.clearStorageOnUrlChange);
  }

  disconnect() {
    document.removeEventListener("turbo:visit", this.clearStorageOnUrlChange);
  }

  clearStorageOnUrlChange() {
    localStorage.removeItem('contentIds');
  }
}
